import React, { PropsWithChildren, Suspense } from "react";
import { gtmHeadTag } from "@leafly-com/web-utils";
import dynamic from "next/dynamic";
import Script from "next/script";

import { SnackBarProvider } from "context/SnackBarContext";

import AgeGate from "components/AgeGate";
import { ModalFrame } from "components/botanic/Modal/ModalFrame";
import { CookiePopup } from "components/CookiePopup";
import Footer from "components/Footer";
import { GooglePublisherTagScript } from "components/GooglePublisherTagScript";
import { PageTransitionProgressBar } from "components/PageTransitionProgressBar";
import { Toaster } from "components/Toaster";
import { WeedfettiCannon } from "components/Weedfetti";

import { AppSideEffects } from "./AppSideEffects";

const ChatwootWidget = dynamic(() => import("components/ChatwootWidget"), {
  ssr: false,
});

/**
 * This Layout component reflects the layout that can be shared between the
 * App Router and Pages Router pges. Anything added to this layout _must_ be
 * compatible with both patterns.
 */
const Layout: React.FC<
  PropsWithChildren<{
    hideFooter?: boolean;
  }>
> = ({ children, hideFooter = false }) => (
  <ModalFrame>
    <Script
      async
      id="google-tag-manager"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{ __html: gtmHeadTag }}
    />
    <GooglePublisherTagScript />
    <Toaster />

    <Suspense>
      <AgeGate />
      <AppSideEffects />
      <CookiePopup />
    </Suspense>

    <SnackBarProvider>
      {children}
      {!hideFooter && <Footer />}
    </SnackBarProvider>

    <WeedfettiCannon />
    <ChatwootWidget />
    <PageTransitionProgressBar />
  </ModalFrame>
);

export default Layout;
